import React, {useEffect} from 'react';
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';
import { signal, signalPageView } from "./telemetry";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Projects from "./projects/page";
import About from "./about/page";
import Stats from "./about/stats";

function TelemetryTracker() {
    const location = useLocation();

    useEffect(() => {
        signalPageView(window.location.origin + location.pathname + location.search);
    }, [location.pathname, location.search]);

    return null;
}

function ClovisAge() {
  const currentDate = new Date();
  return (currentDate.getFullYear() - 2002);
}

function HomePage() {
    const handleCVDownload = () => {
        signal("CV.Download");
    };

    return(
        <div>
        <div className="hero min-h-screen bg-base-200">
            <div className="hero-content flex-col lg:flex-row">
                <img className="w-full h-auto rounded-lg shadow-2xl lg:max-w-sm" src="/moi.png" alt="Clovis Krzyzanowski"/>
                <div>
                    <h1 className="text-5xl font-bold">Clovis Krzyzanowski</h1>
                    <p className="py-6">{ ClovisAge() } year old CS student currently studying at UTC (Université Technologique de Compiègne).
                    </p>
                    <div>
                        <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#ComputerScience</span>
                        <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#Paris</span>
                    </div>
                    <a href="/Clovis_Krzyzanowski_CV.pdf" onClick={handleCVDownload} target="_blank"
                       rel="noopener noreferrer" ><button className="btn btn-primary">Download CV</button></a>
                </div>
            </div>
        </div>
        <Stats/>
        <About/>
        <Projects/>
        </div>
    )
}

function GoodPlansPage() {
    return (
        <div>
            <div className="hero min-h-screen bg-base-200 flex flex-col items-center justify-center text-center">
                <h1 className="text-4xl font-bold mb-4">Support for GoodPlans</h1>

                <img className="w-32 h-auto rounded-lg shadow-2xl mb-6 lg:max-w-sm" src="/GoodPlansIcon.png" alt="GoodPlans icon"/>
                <a
                    href="https://apps.apple.com/fr/app/goodplans/id6742191887"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <button className="btn btn-primary mb-4">App Store</button>
                </a>

                <p className="py-6 text-justify max-w-3xl mx-auto">
                    Struggling to balance classes, sports, and study time?
                    GoodPlans is your all-in-one scheduling assistant designed for university
                    students who want to stay organized without wasting time on manual planning.
                    Enjoy an uninterrupted experience with no ads or distractions.
                </p>

                <p className="text-md mb-6">If you have any questions or feedback, feel free to reach out:</p>
                <a href="mailto:clovis@krzyzanowski.fr" className="text-blue-500 mb-4">
                    Email me for support
                </a>
            </div>
        </div>
    )
}

function TikkitPage() {
    return (
        <div>
            <div className="hero min-h-screen bg-base-200 flex flex-col items-center justify-center text-center">
                <h1 className="text-4xl font-bold mb-4">Support for Tikkit</h1>

                <img className="w-32 h-auto rounded-lg shadow-2xl mb-6 lg:max-w-sm" src="/TikkitIcon.png" alt="Tikkit icon"/>
                <a
                    href="https://apps.apple.com/us/app/tikkit/id6748647680"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <button className="btn btn-primary mb-4">App Store</button>
                </a>

                <p className="py-6 text-justify max-w-3xl mx-auto">
                    Assign tasks, stay organized, and sync everything across your devices all in one minimalist to-do app.
                    No ads, no clutter, just focus.
                </p>

                <p className="text-md mb-6">If you have any questions or feedback, feel free to reach out:</p>
                <a href="mailto:clovis@krzyzanowski.fr" className="text-blue-500 mb-4">
                    Email me for support
                </a>
            </div>
        </div>
    )
}

function FreqPilotPage() {
    return (
        <div>
            <div className="hero min-h-screen bg-base-200 flex flex-col items-center justify-center text-center">
                <h1 className="text-4xl font-bold mb-4">Support for FreqPilot</h1>

                <img className="w-32 h-auto rounded-lg shadow-2xl mb-6 lg:max-w-sm" src="/FreqPilotIcon.png" alt="FreqPilot icon"/>
                <a
                    href="https://apps.apple.com/us/app/freqpilot-freqtrade-app/id6757278790"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <button className="btn btn-primary mb-4">App Store</button>
                </a>

                <p className="py-6 text-justify max-w-3xl mx-auto">
                    FreqPilot is the companion app for your Freqtrade trading bot. Monitor your trades, track performance, and stay in control.
                </p>

                <p className="text-md mb-6">If you have any questions or feedback, feel free to reach out:</p>
                <a href="mailto:clovis@krzyzanowski.fr" className="text-blue-500 mb-4">
                    Email me for support
                </a>
            </div>
        </div>
    )
}

export default function App() {
  return (
      <Router>
          <TelemetryTracker />
          <Navbar/>
              <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/goodplans" element={<GoodPlansPage />} />
                  <Route path="/tikkit" element={<TikkitPage />} />
                  <Route path="/freqpilot" element={<FreqPilotPage />} />
              </Routes>
          <Footer/>
      </Router>
  );
};
